import RequestContainer from "./RequestContainer";
import RequestStore from "./RequestStore";

export default RequestStore(RequestContainer);